import React from 'react';

import classes from './TupleBoxLeft.scss';

const tupleBoxLeft = (props) => <div className={[classes.Box, `phone-f-fill`, !props.isVisible ? 'u-phoneHide' : null].join(' ')}>{props.children}</div>;

export default tupleBoxLeft;


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTuple/TupleBoxLeft/TupleBoxLeft.js